import React from 'react';
import {Box, Stack} from '@mui/material';
import {Button, Icon, IconName} from '@lightricks/react-design-system';
import {ButtonProps} from '@lightricks/react-design-system/dist/components/button/ButtonProps';
import translate from '@/utils/translate';
import useNavigation from '@/hooks/use-navigation';
import FeatureDetails from '../../assets/type';
import ThumbnailStack from './ThumbnailStack';

export type SingleActionBarProps = {
  clearButtonProps: ButtonProps;
  clearButtonText: string;
  clearButtonOnClick: () => void;
  fileName?: string;
  featureDetails: FeatureDetails;
  isDisabled?: boolean;
};

function SingleActionBar({
  clearButtonProps,
  clearButtonText,
  clearButtonOnClick,
  fileName,
  featureDetails,
  isDisabled = false,
}: SingleActionBarProps) {
  const {navigate} = useNavigation();
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
    >
      <Box
        sx={{
          flex: '1',
          display: 'flex',
          justifyContent: 'flex-start',
          overflow: 'hidden',
          minWidth: 0,
        }}
      >
        <ThumbnailStack fileName={fileName} />
      </Box>
      <Box sx={{flex: '1', display: 'flex', justifyContent: 'center'}}>
        <Button
          appearance="neutral"
          mode="filled"
          size="large"
          style={{width: '250px'}}
          disabled={isDisabled}
          onClick={() => {
            navigate(featureDetails.navString);
          }}
        >
          {featureDetails?.icon && (
            <Icon
              size="medium"
              appearance="white"
              name={featureDetails?.icon as IconName}
              style={{marginRight: '8px'}}
            />
          )}
          {translate(featureDetails?.name)}
        </Button>
      </Box>
      <Box sx={{flex: '1', display: 'flex', justifyContent: 'flex-end'}}>
        <Button {...clearButtonProps} onClick={clearButtonOnClick}>
          {clearButtonText}
        </Button>
      </Box>
    </Stack>
  );
}

export default SingleActionBar;
